import { Component, OnInit, Input, Output } from '@angular/core';
import { EventEmitter } from 'events';

@Component({
  selector: 'app-consulta-limite-credito-pj',
  templateUrl: './consulta-limite-credito-pj.component.html',
  styleUrls: ['./consulta-limite-credito-pj.component.scss']
})
export class ConsultaLimiteCreditoPjComponent implements OnInit {
  title = "LIMITE DE CRÉDITO - PJ";

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  msgNull = '0,00';

  constructor() { }

  ngOnInit() {
  }

}
